import { ref, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase/FirebaseCredential";
import axios from "axios";
export const fetchJsonFile = async () => {
  try {
    // Reference to the JSON file in Cloud Storage
    const fileRef = ref(storage, "exerciselist/exercises.json");

    // Get the dynamic download URL
    const url = await getDownloadURL(fileRef);
    console.log("Download URL:", url);

    // Fetch JSON data using axios
    const response = await axios.get(url);
    return response.data;

  } catch (error: any) {
    // Firebase Storage specific error handling
    console.warn("Failed to fetch JSON file:", error?.message ?? error);

    if (error.code) {
      switch (error.code) {
        case 'storage/object-not-found':
          console.error("File not found at the specified path.");
          break;
        case 'storage/unauthorized':
          console.error("Unauthorized access to the file.");
          break;
        case 'storage/canceled':
          console.error("Download was canceled.");
          break;
        case 'storage/unknown':
        default:
          console.error("Unknown storage error occurred.");
          break;
      }
    }

    // Optional: return null or fallback
    return null;
  }
};
// export const fetchJsonFile = async () => {
//   try {
//     // Reference to the JSON file in Cloud Storage
//     const fileRef = ref(storage, "exerciselist/exercises.json");

//     // Get the dynamic download URL (usually returns .firebasestorage.app domain)
//     const url = await getDownloadURL(fileRef);
//     console.log("Download URL:", url);

//     // Try fetching via dynamic URL
//     const response = await axios.get(url);
//     return response.data;
//   } catch (error) {
//     console.warn("Primary fetch failed, trying fallback with fixed domain");

    // try {
    //   // Extract the token from the failed dynamic URL
    //   const fileRef = ref(storage, "exerciselist/exercises.json");
    //   const originalUrl = await getDownloadURL(fileRef);
    //   const urlObj = new URL(originalUrl);
    //   const token = urlObj.searchParams.get("token");

    //   // Construct fallback URL using .appspot.com
    //   const fallbackUrl = `https://firebasestorage.googleapis.com/v0/b/bench-dev-93520.appspot.com/o/exerciselist%2Fexercises.json?alt=media&token=${token}`;

    //   const fallbackResponse = await axios.get(fallbackUrl);
    //   return fallbackResponse.data;
    // } catch (fallbackError) {
    //   console.error("Both fetch attempts failed:", fallbackError);
    //   throw fallbackError;
    // }
//   }
// };
